import { Controller } from "@hotwired/stimulus";

const BONUS_CATEGORIES = ["special_bonus", "overtime_pay", "performance_bonus", "other_bonus"];
const DEDUCTION_CATEGORIES = ["disciplinary", "absence", "salary_retention", "salary_overpayment", "other_deduction"];

export default class extends Controller {
  static targets = ["typeRadio", "categorySelect"];

  connect() {
    this.filterCategories();
  }

  typeChanged() {
    this.filterCategories();
  }

  filterCategories() {
    const selectedType = this.element.querySelector(
      'input[name="payslip_adjustment[adjustment_type]"]:checked'
    );
    if (!selectedType || !this.hasCategorySelectTarget) return;

    const type = selectedType.value;
    const select = this.categorySelectTarget;
    const allowedCategories =
      type === "bonus" ? BONUS_CATEGORIES : DEDUCTION_CATEGORIES;

    Array.from(select.options).forEach((option) => {
      if (option.value === "") return; // Keep prompt
      option.hidden = !allowedCategories.includes(option.value);

      // Reset if current selection is no longer valid
      if (option.selected && option.hidden) {
        select.value = "";
      }
    });

    // Also handle optgroups
    Array.from(select.querySelectorAll("optgroup")).forEach((group) => {
      const visibleOptions = Array.from(group.options).filter((o) => !o.hidden);
      group.hidden = visibleOptions.length === 0;
    });
  }
}
